module.exports = __webpack_public_path__ + "static/media/logo-meep-novo.4cbc3953.png";